import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { CustomText } from "../../../components/CustomText";

import { GetNarratorById } from "../../../api/api.service";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey, MODULE_KEYS } from "../../../api/api.keys";
import { hasData } from "../../../utils/commonUtils";
import { LoaderFallbackUI } from "../../../components/LoaderFallbackUI";
import GoalStatus from "../../../constants/GoalStatus";
import { SummaryCard } from "../../../components/SummaryCard";
import APP_CONFIG from "../../../APP_CONFIG";
import { APP_ROUTES, getParamsAttachedRoute } from "../../../helpers/routeHelpers";

const NarratorDetails = () => {
    const location = useLocation();
    const history = useHistory();

    const id = location.pathname.split("/").pop();

    let { useFetch } = useRequestProcessor();
    const { data, isLoading, isFetching } = useFetch(
        getKey([MODULE_KEYS.NARRATOR_DETAILS], { id }),
        async ({ signal }) =>
            await GetNarratorById({
                id
            })
    );

    const getAudioContentRoute = (categoryId) => {
        const routesMap = {
            1: { path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_DETAILS, param: "singlesID" },
            2: { path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_DETAILS, param: "seriesID" },
            3: {
                path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_DETAILS,
                param: "soundscapesID"
            },
            4: { path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_DETAILS, param: "sharesID" }
        };

        return routesMap[categoryId] || routesMap[2]; // Default to series details
    };

    if (isFetching || isLoading || !hasData(data)) {
        return (
            <div style={{ height: "70vh" }}>
                <LoaderFallbackUI isLoader={isFetching} className={"h-100"} />
            </div>
        );
    }

    return (
        <Container fluid className="p-4 goal-detail-container ">
            <Row className="mb-4">
                <Col md={6}>
                    <CustomText
                        title={"Narrator Name"}
                        description={data?.name || "-"}
                        titleClass="label-classes"
                        descClass="desc-classes"
                    />
                </Col>

                <Col md={6}>
                    <CustomText
                        titleClass="label-classes"
                        descClass={`  ${
                            data?.status ? "status-common-class" : ""
                        } ${GoalStatus.getLabelClass(data?.status)}`}
                        title={"Status"}
                        description={GoalStatus.getDisplayTextKey(data?.status) || "N/A"}
                    />
                </Col>
            </Row>
            {data?.album?.length ? (
                <Row className="mb-2 session-container">
                    <Col xs={12} className="session-heading">
                        Linked Audios
                    </Col>
                    <div className="narrator-audio">
                        {/*  */}
                        {data?.album?.map((album) => {
                            return (
                                <div
                                    className="narrator-audio-container"
                                    onClick={() => {
                                        const { path, param } = getAudioContentRoute(
                                            album?.categoryId
                                        );
                                        history.push(
                                            getParamsAttachedRoute(path, { [param]: album?.id })
                                        );
                                    }}
                                >
                                    <div className="narrator-audio-container-img">
                                        <img
                                            src={
                                                `${album?.thumbnail?.location}${
                                                    album?.thumbnail?.thumbPath ||
                                                    album?.thumbnail?.path
                                                }` || APP_CONFIG.IMAGES.AVATAR_PLACEHOLDER
                                            }
                                            alt={album?.thumbnail?.name || "Thumbnail"}
                                            className="narrator-audio-container-img-thumbnail"
                                        />
                                    </div>
                                    <div className="narrator-audio-container-details">
                                        <span className="narrator-audio-container-details-name">
                                            {album?.title || "-"}
                                        </span>
                                    </div>
                                </div>
                                // <Col md={2} className="py-2">

                                // </Col>
                            );
                        })}
                    </div>
                </Row>
            ) : null}
        </Container>
    );
};

export default NarratorDetails;
